import { EMAIL_ACTION } from './actionTypes'

export const EmailStateSelectors = {
	subscribe:     (state) => state.auth[EMAIL_ACTION.SUBSCRIBE],
}
